import { apiPut } from "../baseApi";

export const currentupdate = async (id, data) => {
  try {
    const response = await apiPut("_user", id, data, {}, "/primary-district");
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
